var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramGalleryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    stroke: "#03A9F4",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 6,
    height: 4.5,
    rx: 1.3,
    stroke: "#03A9F4",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9.75,
    width: 6,
    height: 4.5,
    rx: 1.3,
    stroke: "#03A9F4",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14.5,
    width: 6,
    height: 4.5,
    rx: 1.3,
    stroke: "#03A9F4",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5,
    width: 6,
    height: 4.5,
    rx: 1.3,
    stroke: "#03A9F4",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9.75,
    width: 6,
    height: 4.5,
    rx: 1.3,
    stroke: "#03A9F4",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14.5,
    width: 6,
    height: 4.5,
    rx: 1.3,
    stroke: "#03A9F4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramGalleryActive);
export default __webpack_public_path__ + "static/media/instagram-gallery-active.ea82c101223a8c7cecb25e99d30dcf82.svg";
export { ForwardRef as ReactComponent };